import { apiRequest } from '@/shared/api/client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import type { Tag } from '../model/types';

export const tagApi = {
  list: async (): Promise<{ tags: Tag[] }> => {
    const tags = await apiRequest<Tag[]>({ method: 'GET', url: ENDPOINTS.TAGS.LIST });
    return { tags };
  },
};
